import * as Website from '../Config/Website.js';
import { Splide } from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { gsap } from "gsap";


const carousel = () => {
  function getDeviceFlags() {
    const w = window.innerWidth;

    return {
      pc: w >= 961,
      tablet: w >= 768 && w < 961,
      sp: w < 768
    };
  }
  let device = getDeviceFlags();

  const homePickupSliderElm = document.querySelector('.js-homePickupSlider');
  if(homePickupSliderElm){
    let homePickupSlider = new Splide( homePickupSliderElm, {
      type         : 'loop',
      autoWidth    : false,
      perMove      : 1,
      fixedWidth: device.pc ? '36rem' : device.tablet ? '29.2rem' : '29rem',
      gap: device.pc ? '4rem' : device.tablet ? '3rem' : '2rem',
      speed        : 600,
      rewindSpeed  : 600,
      flickPower   : 50,
      updateOnMove : true,
      arrow        : true,
      pagination  : false,
    } )
    homePickupSlider.mount();

    const adjustPickupSlider = () => {
      device = getDeviceFlags();
      homePickupSlider.options = {
        fixedWidth: device.pc ? '36rem' : device.tablet ? '29.2rem' : '29rem',
        gap: device.pc ? '4rem' : device.tablet ? '3rem' : '2rem',
      };
      homePickupSlider.refresh();
    };
    homePickupSlider.on('resize', adjustPickupSlider);
  }

  const homeMemberSliderElm = document.querySelector('.js-homeMemberSlider');
  if(homeMemberSliderElm){
    let homeMemberSlider = new Splide( homeMemberSliderElm, {
      type         : 'loop',
      autoWidth    : false,
      perMove      : 1,
      fixedWidth: device.pc ? '30rem' : device.tablet ? '26.8rem' : '26rem',
      gap: device.pc ? '4rem' : device.tablet ? '3rem' : '2rem',
      speed        : 600,
      rewindSpeed  : 600,
      flickPower   : 50,
      updateOnMove : true,
      arrow        : true,
      pagination  : false,
    } )
    homeMemberSlider.mount();

    const adjustMemberSlider = () => {
      device = getDeviceFlags();
      homeMemberSlider.options = {
        fixedWidth: device.pc ? '30rem' : device.tablet ? '26.8rem' : '26rem',
        gap: device.pc ? '4rem' : device.tablet ? '3rem' : '2rem',
      };
      homeMemberSlider.refresh();
    };
    homeMemberSlider.on('resize', adjustMemberSlider);
  }

  const homeSpecialSliderElm = document.querySelector('.js-homeSpecialSlider');
  if(homeSpecialSliderElm){
    let homeSpecialSlider = new Splide( homeSpecialSliderElm, {
      type         : 'loop',
      autoWidth    : false,
      perMove      : 1,
      fixedWidth: device.pc ? '54rem' : device.tablet ? '36rem' : '29.4rem',
      gap: device.pc ? '4rem' : device.tablet ? '3rem' : '2rem',
      speed        : 600,
      rewindSpeed  : 600,
      flickPower   : 50,
      updateOnMove : true,
      arrow        : true,
      pagination  : false,
    } )
    homeSpecialSlider.mount();

    const adjustSpecialSlider = () => {
      device = getDeviceFlags();
      homeSpecialSlider.options = {
        fixedWidth: device.pc ? '54rem' : device.tablet ? '36rem' : '29.4rem',
        gap: device.pc ? '4rem' : device.tablet ? '3rem' : '2rem',
      };
      homeSpecialSlider.refresh();
    };
    homeSpecialSlider.on('resize', adjustSpecialSlider);
  }

  arrows();

  const strengthSliderElm = document.querySelector('.js-strengthSlider');
  if(strengthSliderElm){
    let strengthSlider = new Splide( strengthSliderElm, {
      type         : 'fade',
      rewind      : true,
      arrow        : true,
      pagination  : false,
    } )
    strengthSlider.mount();

    const strengthModal = document.querySelectorAll('.js-strengthModal');
    strengthModal.forEach((modal, index) => {
      modal.addEventListener('click', () => {
        strengthSlider.go(index);
      });
    });
  }

  const purposeNavSliderElm = document.querySelector('.js-purposeNavSlider');
  if(purposeNavSliderElm){
    const purposeNavSliderChildren = purposeNavSliderElm.querySelectorAll('.splide__slide');
    const sortTarget = Array.from(purposeNavSliderChildren).slice(2);
    // sortTargetをランダムに並び替え
    for (let i = sortTarget.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [sortTarget[i], sortTarget[j]] = [sortTarget[j], sortTarget[i]];
    }
    // 並び替えた要素を親要素に再追加
    sortTarget.forEach((child, index) => {
      purposeNavSliderElm.querySelector('.splide__list').appendChild(child);
      child.querySelector('a').setAttribute('data-index', index + 2);
    });

    let purposeNavSlider = new Splide( purposeNavSliderElm, {
      type         : 'loop',
      autoWidth    : false,
      fixedWidth: device.pc ? '20rem' : device.tablet ? '19.4rem' : '14.6rem',
      gap: device.pc ? '3.5rem' : device.tablet ? '3rem' : '2.2rem',
      arrows       : false,
      pagination  : false,
      drag         : false,
      autoScroll: {
        speed: 1,
        pauseOnFocus  : false,
        pauseOnHover  : false,
      },
    } )
    purposeNavSlider.mount( { AutoScroll } );

    const adjustSpecialSlider = () => {
      device = getDeviceFlags();
      purposeNavSlider.options = {
        fixedWidth: device.pc ? '20rem' : device.tablet ? '19.4rem' : '14.6rem',
        gap: device.pc ? '3.5rem' : device.tablet ? '3rem' : '2.2rem',
      };
      purposeNavSlider.refresh();
    };
    purposeNavSlider.on('resize', adjustSpecialSlider);
  }
}

const arrows = () => {
  const commonSliderArrows = document.querySelectorAll('.js-commonSliderArrows');

  commonSliderArrows.forEach((wrap) => {
    const buttons = wrap.querySelectorAll('.splide__arrow');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        button.classList.add('is-animating');
        setTimeout(() => {
          button.classList.remove('is-animating');
        }, 100);
      });
    });
  });
};

const init = () => {
  carousel();
}
export default init;